import { useAssistantStore } from '@/stores/useAssistantStore';
import { ChatInterface } from './ChatInterface';
import { VSTACKHologram } from './VSTACKHologram';
import { StatusPanel } from './StatusPanel';
import { DAWControls } from './DAWControls';
import { TTSControls } from './TTSControls';
import { CommandPalette } from './CommandPalette';
import { SettingsPanel } from './SettingsPanel';
import { motion, AnimatePresence } from 'framer-motion';

export function AssistantPanel() {
  const { activeDock, panelOpen } = useAssistantStore();

  const renderContent = () => {
    switch (activeDock) {
      case 'chat':
        return <ChatInterface />;
      case 'vstack':
        return <VSTACKHologram />;
      case 'status':
        return <StatusPanel />;
      case 'daw':
        return <DAWControls />;
      case 'tts':
        return <TTSControls />;
      case 'commands':
        return <CommandPalette />;
      case 'ai':
        return <ChatInterface />; // AI Wand uses chat for now
      case 'settings':
        return <SettingsPanel />;
      default:
        return <ChatInterface />;
    }
  };

  return (
    <AnimatePresence>
      {panelOpen && (
        <motion.div
          initial={{ opacity: 0, y: 20, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.95 }}
          transition={{ duration: 0.2, ease: [0.16, 1, 0.3, 1] }}
          className="absolute bottom-24 left-1/2 -translate-x-1/2 w-[min(900px,92vw)] h-[min(600px,70vh)] z-50"
        >
          <div className="h-full glass-panel rounded-2xl overflow-hidden holographic-glow flex flex-col">
            {/* Header */}
            <div className="flex items-center justify-between px-4 py-2 border-b border-border-subtle/50 bg-surface/20">
              <div className="flex items-center gap-2">
                <span className="text-[10px] uppercase tracking-[0.2em] text-violet font-medium">APE_XØRBIT</span>
                <span className="text-tertiary text-xs">|</span>
                <span className="text-[10px] uppercase tracking-wider text-tertiary">{activeDock}</span>
              </div>
              <div className="flex items-center gap-1.5">
                <div className="w-1.5 h-1.5 rounded-full bg-neon animate-pulse" />
                <span className="text-[10px] text-tertiary">ONLINE</span>
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-hidden p-3">
              <AnimatePresence mode="wait">
                <motion.div
                  key={activeDock}
                  initial={{ opacity: 0, x: 10 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: -10 }}
                  transition={{ duration: 0.15 }}
                  className="h-full"
                >
                  {renderContent()}
                </motion.div>
              </AnimatePresence>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
